module.exports = 'apinnecke.sortButton';

var angular = require('angular');

if (!angular.component) {
  require('angular-component');
}

angular
  .module(module.exports, [])
  .component('sortButton', {
    bindings: {
      order: '=',
      value: '@',
    },
    transclude: true,
    controller: SortButtonController,
    template: `
      <button class="btn btn-link" ng-click="$ctrl.setOrder()">
          <span ng-show="$ctrl.order.order === $ctrl.value">
              <i ng-show="$ctrl.order.reverse === true">&#x25BC;</i>
              <i ng-show="$ctrl.order.reverse === false">&#x25B2;</i>
          </span>
          <ng-transclude></ng-transclude>
      </button>
    `,
  });

function SortButtonController() {}

SortButtonController.prototype.setOrder = function() {
  if (this.order.order !== this.value) {
    this.order.order = this.value;
    this.order.reverse = false;
  } else {
    this.order.reverse = !this.order.reverse;
  }
}
